import FlipGreetingCard from "./FlipGreetingCard";

export default function FinalOverlay() {

  return (
    <div className="final-overlay">

      <FlipGreetingCard />

    </div>
  );

}